module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-500.f9bdf9b7f08ecd9c2484ca884b96acd7.woff";